// @ts-ignore
export default function (num, size = 5){
    if(!num) return '-';
    let s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}